module.exports = __webpack_public_path__ + "images/videos/bootstrap.mp4";